import { Field } from 'Util/Query';

export class LotteryPromoQuery {
    getCreateLotteryEntryMutation(options) {
        const { lottery_promo_name, gqm_id } = options;
        return new Field('createLotteryEntry')
            .addArgument('lottery_promo_name', 'String!', lottery_promo_name)
            .addArgument('gqm_id', 'String', gqm_id)
            .addFieldList(this.getCreateLotteryEntryFields());
    }

    getCreateLotteryEntryFields() {
        return [
            'entry_id',
            'lottery_promo_name',
            'success',
            'created_at',
        ];
    }

    // New method for in-store receipt submission
    getSubmitStoreReceiptMutation(options) {
        const { email, receiptNumber, lotteryName, storeId, telephoneNumber, storeName, privacyPolicy, termsAndConditions, subscribeNewsletter} = options;
        return new Field('submitStoreReceipt')
            .addArgument('input', 'SubmitStoreReceiptInput!', {
                email,
                receiptNumber,
                lotteryName,
                storeId,
                telephoneNumber,
                storeName,
                privacyPolicy,
                termsAndConditions,
                subscribeNewsletter
            })
            .addFieldList(this.getSubmitStoreReceiptFields());
    }

    getSubmitStoreReceiptFields() {
        return [
            'success',
            'message',
        ];
    }
}

export default new LotteryPromoQuery();
